import { mapEntityProperties } from '@/utils/mapEntityProperties'
import moment from 'moment'
import { ShiftFilterEntity } from '../../domain/entities/ShiftFilterEntity'

export class ShiftFilterModel extends ShiftFilterEntity {
  fromStartTime?: string
  toStartTime?: string
  fromDuration?: string
  toDuration?: string
  regionId?: number
  toStartDateTime?: string
  fromStartDateTime?: string
  constructor(dataDto: ShiftFilterEntity) {
    super()
    mapEntityProperties<ShiftFilterModel>(this, dataDto, {
      exclude: ['time', 'duration'],
      map: {
        regionId: dataDto.region?.id,
        fromStartDateTime: dataDto.startDateTime?.[0],
        toStartDateTime: dataDto.startDateTime?.[1],
        fromDuration: dataDto.duration
          ? dataDto.duration[0]
            ? moment(dataDto.duration[0]).utc().format('HH:mm:ss')
            : undefined
          : undefined,
        toDuration: dataDto.duration
          ? dataDto.duration[1]
            ? moment(dataDto.duration[1]).utc().format('HH:mm:ss')
            : undefined
          : undefined
      }
    })
  }
}
